import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const SqueezeForm = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://formrobin.com/js/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Opcional: remover script ao desmontar
    };
  }, []);

  return (
    <section id="cadastro" className="py-24 bg-stone-100 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-stone-900 mb-6">
            Acesso <span className="italic text-amber-700">VIP</span> UniPET
          </h2>
          <p className="text-lg text-stone-600 max-w-xl mx-auto font-medium">
            Cadastre-se abaixo para receber seu cupom de 15% e ser notificado sobre aberturas de agenda e serviços premium.
          </p>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-[2.5rem] p-4 sm:p-12 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.1)] border border-stone-200"
        >
          {/* Embed do FormRobin */}
          <div className="formrobin-embed" data-path="/f/j50v96w"></div>
          
          <div className="mt-12 pt-8 border-t border-stone-100 flex flex-col sm:flex-row items-center justify-center gap-10">
            <div className="flex items-center gap-3 text-sm text-stone-500 font-bold uppercase tracking-widest">
              <SafeIcon name="Shield" className="w-5 h-5 text-amber-600" />
              Privacidade Garantida
            </div>
            <div className="flex items-center gap-3 text-sm text-stone-500 font-bold uppercase tracking-widest">
              <SafeIcon name="Clock" className="w-5 h-5 text-amber-600" />
              Acesso Antecipado
            </div>
          </div>
        </motion.div>
      </div>

      {/* Detalhe de textura de papel no fundo */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{ backgroundImage: 'url("https://www.transparenttextures.com/patterns/paper-fibers.png")' }} />
    </section>
  );
};

export default SqueezeForm;